module.exports = __webpack_public_path__ + "media/packs/images/flags/SM-d4901548d50c919e3717638a08133a32.svg";